import { render, staticRenderFns } from "./SuppliesCategoryFormModal.vue?vue&type=template&id=5af1d7a2&"
import script from "./SuppliesCategoryFormModal.ts?vue&type=script&lang=js&"
export * from "./SuppliesCategoryFormModal.ts?vue&type=script&lang=js&"
import style0 from "./SuppliesCategoryFormModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports